export default {
  // 获取租户是否开启游客模式
  getTouristType: {
    url: '/mall/nologin/rule/getTouristType',
    type: 'get'
  },
  common: {
    // 获取租户白名单列表
    getWhiteList: {
      url: '/mall/nologin/rule/whiteList',
      type: 'get'
    }
  }
}
